module.exports = __webpack_public_path__ + "static/media/cyuce001.74d19db8.png";